/* tslint:disable max-line-length */

type Callback<T, E> = (err: E, result: T) => void

export function promisify<T, E>(f: (cb: Callback<T, E>) => void, context?: any): () => Promise<T>
export function promisify<T, E, A>(f: (arg: A, cb: Callback<T, E>) => void, context?: any): (arg: A) => Promise<T>
export function promisify<T, E, A, A2>(f: (arg: A, arg2: A2, cb: Callback<T, E>) => void, context?: any): (arg: A, arg2: A2) => Promise<T>
export function promisify<T, E, A, A2, A3>(f: (arg: A, arg2: A2, arg3: A3, cb: Callback<T, E>) => void, context?: any): (arg: A, arg2: A2, arg3: A3) => Promise<T>
export function promisify<T, E, A, A2, A3, A4>(f: (arg: A, arg2: A2, arg3: A3, arg4: A4, cb: Callback<T, E>) => void, context?: any): (arg: A, arg2: A2, arg3: A3, arg4: A4) => Promise<T>
export function promisify<T, E, A, A2, A3, A4, A5>(f: (arg: A, arg2: A2, arg3: A3, arg4: A4, arg5: A5, cb: Callback<T, E>) => void, context?: any): (arg: A, arg2: A2, arg3: A3, arg4: A4, arg5: A5) => Promise<T>

export function promisify(fn: any, context?: any) {
	return (...args: any[]) => {
		return new Promise((resolve, reject) => {
			args.push((err: any, ...values: any[]) =>
				err != null
					? reject(err)
					: resolve(...values)
			)
			fn.apply(context, args)
		})
	}
}
